import React from "react";
import { Tooltip } from "@mui/material";
import {
  getCallActionsForContext,
  isElevenLabsAvailable,
} from "../../config/callActionOptions";
import { useElevenLabsDisclaimer } from "../../hooks/useElevenLabsDisclaimer";
import ElevenLabsBetaDisclaimerModal from "./ElevenLabsBetaDisclaimerModal";

const ELEVENLABS_DISABLED_NOTE = "You must enable recording and transcription to use ElevenLabs.";
const IVR_DISABLED_NOTE = "You can't configure separate business hours here because Business Hours are already enabled at the route level.";

const CallActionOptionsList = ({
  context,
  route,
  enableBusinessHours = false,
  onSelect,
}) => {
  const actions = getCallActionsForContext(context);
  const elevenLabsAvailable = isElevenLabsAvailable(route);
  const {
    requestConfirmation,
    disclaimerOpen,
    acknowledgeDisclaimer,
    cancelDisclaimer,
  } = useElevenLabsDisclaimer();

  const handleSelectAction = (actionType) => {
    if (actionType === "ai_agent" && !elevenLabsAvailable) return;
    if (actionType === "ivr" && enableBusinessHours) return;
    if (actionType === "ai_agent") {
      requestConfirmation(() => onSelect(actionType));
      return;
    }
    onSelect(actionType);
  };

  return (
    <>
      <div className="flex flex-col space-y-3">
        {actions.map((action, idx) => {
          const isElevenLabs = action.type === "ai_agent";
          const isIvr = action.type === "ivr";
          const elevenLabsDisabled = isElevenLabs && !elevenLabsAvailable;
          const ivrDisabled = isIvr && enableBusinessHours;
          const disabled = elevenLabsDisabled || ivrDisabled;
          const tooltipText = elevenLabsDisabled
            ? ELEVENLABS_DISABLED_NOTE
            : ivrDisabled
              ? IVR_DISABLED_NOTE
              : "";
          const subtitle = disabled ? tooltipText : action.subtitle;
          const rowClass = disabled
            ? "opacity-60 cursor-not-allowed"
            : "hover:bg-gray-100 cursor-pointer";

          return (
            <Tooltip key={action.type} title={tooltipText} placement="top">
              <div
                onClick={() => handleSelectAction(action.type)}
                className={`flex items-start space-x-3 p-3 rounded-lg ${
                  idx === 0 ? "bg-gray-50" : ""
                } ${rowClass} transition`}
              >
                <div className="mt-1">{action.icon}</div>
                <div className="flex-1">
                  <div className="text-sm font-medium text-gray-900 flex items-center gap-2">
                    {action.title}
                  </div>
                  <div className="text-sm text-gray-500">{subtitle}</div>
                </div>
              </div>
            </Tooltip>
          );
        })}
      </div>
      <ElevenLabsBetaDisclaimerModal
        open={disclaimerOpen}
        onAcknowledge={acknowledgeDisclaimer}
        onCancel={cancelDisclaimer}
      />
    </>
  );
};

export default CallActionOptionsList;
